<div [class]="listConfig?.wrapClass">
  <div *ngIf="listConfig?.showInputSearch" class="search">
    <form>
      <mat-form-field class="input-field" appearance="outline">
        <mat-label>{{listConfig?.inputPlaceHolder}}</mat-label>
        <input [placeholder]="listConfig?.inputPlaceHolder || 'Search'" type="text"
              (keyup)="search($event.target.value)"
              (keydown)="search($event.target.value)"
              autocomplete="off" matInput />
      </mat-form-field>
    </form>
  </div>

  <div *ngIf="listConfig?.type === 'radio' && !listConfig?.prev" class="radio">
    <mat-radio-group class="top-brands" [(ngModel)]="selectedOption" labelPosition="before" (change)="onChange.emit($event.value)" color="primary" name="selectedOption">
      <div *ngFor="let item of (filteredList | keyvalue)" class="brand-list">
        <mat-radio-button class="brand" [ngClass]="{'selected': selectedOption===item?.key}" [value]="item?.key" (change)="onRadioBtn.emit(item)" [checked]="selectedOption===item?.key">
          <span *ngIf="listConfig?.showIcon" class="payment-icons-v1" [ngClass]="'OP_'+ item?.key+ ' ' +item?.key?.toUpperCase()"></span>
          <span>{{item?.value}}</span>
        </mat-radio-button>
        <div [hidden]="!(listConfig?.showSubmitBtn && selectedOption===item?.key)" class="submit-btn">
          <app-payment-sip-button [config]="config" (btnClick)="submitPayment.emit(item)"></app-payment-sip-button>
        </div>
      </div>
    </mat-radio-group>
  </div>

  <div *ngIf="listConfig?.type === 'radio' && listConfig?.prev" class="radio">
    <mat-radio-group class="top-brands" [(ngModel)]="selectedOption" labelPosition="before" (change)="onChange.emit($event.value)" color="primary" name="selectedOption">
      <div *ngFor="let item of (filteredList | keyvalue)" class="brand-list">
        <mat-radio-button class="brand" [ngClass]="{'selected': selectedOption===item?.key}" [value]="item?.key" (change)="onRadioBtn.emit(item)" [checked]="selectedOption===item?.key">
          <span *ngIf="listConfig?.showIcon" class="payment-icons-v1" [ngClass]="'OP_'+ item?.value?.payment_mode+ ' ' +item?.value?.payment_mode_value?.toUpperCase()"></span>
          <span *ngIf="!item?.value?.payment_mode">{{item?.value}}</span>
          <span *ngIf="item?.value?.payment_mode === 'CARD'">XXXX {{item?.value?.checksum?.last4}}</span>
          <span *ngIf="item?.value?.payment_mode === 'UPI' && item?.value?.payment_mode_value === 'VPA'">{{item?.value?.checksum}}</span>
          <span *ngIf="item?.value?.payment_mode === 'UPI' && item?.value?.payment_mode_value !== 'VPA'">{{item?.value?.payment_mode_value}}</span>
          <span *ngIf="item?.value?.payment_mode === 'NB'" class="text-uppercase">{{item?.value?.checksum?.name?.toLowerCase()}}</span>
          <span *ngIf="item?.value?.payment_mode === 'WALLET'" class="text-capitalize">{{item?.value?.payment_mode_value?.toLowerCase()}}</span>
        </mat-radio-button>
        <div [hidden]="!(listConfig?.showSubmitBtn && selectedOption===item?.key)" class="submit-btn">
          <app-payment-sip-button [config]="config" (btnClick)="submitPayment.emit(item)"></app-payment-sip-button>
        </div>
      </div>
    </mat-radio-group>
  </div>

  <div *ngIf="listConfig?.type === 'button'" class="button">
    <div *ngFor="let item of (filteredList | keyvalue)" class="top-brands">
      <button (click)="submitPayment.emit(item?.key)" [disabled]="paymentV2?.isOrderLoading" mat-button>
        <span *ngIf="listConfig?.showIcon" class="payment-icons-v1" [ngClass]="item?.key?.toUpperCase()"></span> {{item?.value}}
        <i class="material-icons">arrow_forward_ios</i>
      </button>
    </div>
  </div>
</div>